import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6de5ab34&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5ab34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bytedance/Projects/Simple-Crop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de5ab34')) {
      api.createRecord('6de5ab34', component.options)
    } else {
      api.reload('6de5ab34', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6de5ab34&scoped=true&", function () {
      api.rerender('6de5ab34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "index.vue"
export default component.exports